export default __webpack_public_path__ + "static/media/Mall Music Muzak - Mall Of 1974 - 02 Sale Of The Seventies.96d856f9.mp3";